module.exports = __webpack_public_path__ + "img/capa_58.0e86db95.jpeg";